<template>
  <div class="todays-deal-card">
    <div class="countdown-header flash-bg">
      <div class="left-header-title">
        <!-- 秒杀 -->
        <template v-if="activityInfo.activityType === 1">
          <img :src="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/flashsale-icon@2x.png', { w: 68 })" alt="">
          <span>Flash Sales</span>
        </template>

        <!-- 限时折扣 -->
        <template v-if="activityInfo.activityType === 4">
          <img :src="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/limited-offer-icon@2x.png', { w: 68 })" alt="">
          <span>Limited Offer</span>    
        </template>
        
        <!-- 平台大促 -->
         <template v-if="activityInfo.activityType === 6">
          <img :src="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/big-discount-sale-icon_new@2x.png', { w: 68 })" alt="">
          <span>{{ activityInfo.bigDiscountSale?.title || 'Big Discount Sale' }}</span>
        </template>
      </div>
      <div class="countdown-box">
        <span class="over-down" v-if="isOver">Event has ended.</span>
        <span v-else-if="day < 3">
          Closing in
          <span class="time-item">{{ countdown.hour }}</span>
          <span class="time-dot">:</span>
          <span class="time-item">{{ countdown.minute }}</span>
          <span class="time-dot">:</span>
          <span class="time-item">{{ countdown.second }}</span>
        </span>
        <span v-else>{{ monthFormat }}</span>
      </div>
    </div>

    <div class="price-wrapper">
      <span class="sale-price">
        {{ $currencySymbol() }}
        {{ $toThousandsFn(options.activityPrice) }}
      </span>

      <span class="del-price" v-if="options.activityPrice !== options.listPrice">
        {{ $currencySymbol() }}
        {{ $toThousandsFn(options.listPrice) }}
      </span>

      <span class="discount-rate" v-if="discount >= 0.2">
        <span>{{ discount.toFixed(0) }}% off</span>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useActivityCountdown } from '../useActivityCountdown'
import NP from 'number-precision'

export interface ICountdownOptions {
  queryTime: string,
  endTime: string,
  startTime: string,
  activityPrice: number,
  listPrice: number
}
interface IProps {
  activityInfo: ProductV3.SelectedSkuActivity
  options: ICountdownOptions
}
const props = defineProps<IProps>()
const emits = defineEmits<{ (e: 'countdown:over', activity: ProductV3.SelectedSkuActivity): void }>()
const { $timeToHMS, $tz } = useNuxtApp()

const { day, isOver, countdown } = useActivityCountdown(props.options, props.activityInfo,
  activity => emits('countdown:over', activity), $timeToHMS)
const monthFormat = computed(() => $tz.timeToMonthRange(new Date(props.options.startTime), new Date(props.options.endTime)))
const discount = computed<number>(() => {
  const { activityPrice, listPrice } = props.options

  const _price = listPrice - activityPrice
  const discountPrice: number = NP.divide(_price, listPrice) * 100

  return discountPrice >= 0.2 ? discountPrice : _price
})

</script>

<style lang="scss" scoped>
.todays-deal-card{
  border-radius: 12px;
  color: #fff;
  align-items: center;
  overflow: hidden;
}
.flash-bg{
  padding: 20px 30px;
  background: linear-gradient(90deg, rgba(255, 51, 0, 1) 0%, rgba(255, 51, 0, 1) 0%, rgba(255, 102, 0, 1) 100%, rgba(255, 102, 0, 1) 100%);
}
.countdown-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 42px;
  .left-header-title{
    display: flex;
    align-items: center;
    text-shadow: 0 0 2px #fff;
    img{
      margin-right: 20px;
      height: 48px;
    }
  }
  .countdown-box{
    color: #fff;
    .time-item{
      background-color: #150000;
      display: inline-block;
      padding: 8px 10px;
      border-radius: 8px;
      font-size: 36px;
    }
    .time-dot{
      font-size: 38px;
      margin: 0 10px;
      font-weight: 600;
    }
  }
}

.price-wrapper{
  display: flex;
  align-items: center;
  background-color: #F5F7FA; // rgba($color: #DD3131, $alpha: 0.1);
  color: #150000;
  padding: 30px;
  .sale-price{
    font-size: 58px;
    text-shadow: 0 0 2px #150000;
  }
  .del-price{
    font-size: 28px;
    color: #999;
    margin: 0 20px;
    text-decoration: line-through;
  }
  .discount-rate{
    background-color: #f6c5c5;
    padding: 8px 15px;
    border-radius: 6px;
    color: var(--pc-default-color);
  }
}

.left-price-info{
  .act-type{
    font-size: 32px;
  }
  .discount{
    font-size: 28px;
    margin-left: 20px;
    border-radius: 6px;
    border: 2px solid #fff;
    padding: 4px 10px;
  }
  .price-box{
    // font-size: 42px;
    margin-top: 5px;
    .sale-price{
      font-size: 38px;
    }
    .del-price{
      margin-left: 20px;
      font-size: 24px;
      text-decoration: line-through;
    }
  }
}
.countdown{
  font-size: 42px;
  .over-down{
    font-size: 32px;
  }
}
</style>